/**
 * Why `_app` refused to render a page. Thrown from its `beforeLoad`, which aborts the match
 * so no child loader fires a request that is only going to 401.
 *
 * The reason survives to the screen because the two need opposite treatment: no session is
 * already on its way to the central login (`client.ts` redirects the moment the 401 lands),
 * while a session without the role must never be sent there — the login would hand that
 * person straight back and the two origins would bounce forever.
 */
export class NotSignedIn extends Error {
  constructor(readonly reason: 'no-session' | 'no-role') {
    super(`not signed in: ${reason}`);
    this.name = 'NotSignedIn';
  }
}
